class IFile {
    public file: any = null;
    public label: string = '';
    public base64: string = '';

    constructor(file, label, base64?) {
        this.file = file;
        this.label = label;

        if(base64 != undefined)
            this.base64 = base64;
        else
            this.GetBase64String();
    }

    public SetLabel = (newLabel: string) => {
        this.label = newLabel;
    }

    public GetFileName = () => {
        let extension = ''
        if(this.file != null) {
            const fileStrArr = this.file.name.split('.');
            extension = fileStrArr[fileStrArr.length - 1];
        } else if(this.base64.includes('https://')) {
            const fileStrArr = this.base64.split('/');
            extension = fileStrArr[fileStrArr.length - 1];
        }
        return this.label.replace('.' + extension, '') + '.' + extension;
    }

    //private
    private GetBase64String = () => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
            this.base64 = e.target.result;
        };

        reader.onerror = (e) => {
            console.error("File reading error", e);
        };

        reader.readAsDataURL(this.file);
    }
}
export default IFile;